var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.545 7.13L4.335 4.145V3.71L1.545 0.725L0.525 1.625L2.595 3.92L0.525 6.245L1.545 7.13ZM4.95 7.13L7.74 4.145V3.71L4.95 0.725L3.93 1.625L6 3.92L3.93 6.245L4.95 7.13Z",
    fill: "#B8BEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDash);
export default __webpack_public_path__ + "static/media/doubleDash.f8e8621c79bdfce0642f6ed312a7e78b.svg";
export { ForwardRef as ReactComponent };